<template>
  <div
    class="infoWrapper"
    :class="fileUploadingNum ? 'uploading' : ''"
  >
    <Loading
      :contentSize="true"
      :state="loading"
    >
      <div class="wrapper">
        <h1>{{ $t( "title" ) }}<span>{{ $t( "titleDescr" ) }}</span></h1>

        <File
          :value="file"
          :multiple="true"
          @input="fileSelected( $event.el, $event.fn )"
        />
        <Button
          :class="file ? '' : 'disabled'"
          :disabled="!file"
          @click="send()"
        >
          {{ $t( "SendFiles" ) }}
        </Button>

        <template
          v-if="!fileUploadingNum && filesDatas && filesDatas.length"
        >
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            class="results"

            v-for="f in filesDatas"
          >
            <thead>
              <tr>
                <th colspan="2" class="file"><span>{{ f.name }}</span></th>
              </tr>
              <tr>
                <th>{{ $t( "subject" ) }}</th>
                <th>{{ $t( "area" ) }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="f.status">
              <tr
                v-for="( subj, area ) in  f.info"
              >
                <td>{{ area }}</td>
                <td>
                  <template v-if="$te( 'areas.' + subj )">{{ $t( "areas." + subj ) }}</template>
                  <span v-else style="color: #FF0000">не соответствует</span>
                </td>
              </tr>
              </template>
              <template v-else>
              <tr>
                <td colspan="2" style="color: #FF0000">{{ $t( "parseFailed" ) }}</td>
              </tr>
              </template>
            </tbody>
          </table>



          <Button
            style="margin-top: 2em;"
            @click="exportToFile()"
          >
            {{ $t( "exportToExcel" ) }}
          </Button>

          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            ref="excel"
            style="display: none;"
          >
            <tbody>
              <template
                v-for="f in filesDatas"
              >
                <template v-if="f.status">
                  <tr valign="top">
                    <th colspan="2" align="center" bgcolor="LightGrey">{{ f.name }}</th>
                  </tr>
                  <tr valign="top">
                    <th align="left" bgcolor="LightGrey" style="font-weight: bold;">{{ $t( "subject" ) }}</th>
                    <th align="left" bgcolor="LightGrey" style="font-weight: bold;">{{ $t( "area" ) }}</th>
                  </tr>
                  <tr
                    v-for="( subj, area ) in  f.info"
                    valign="top"
                  >
                    <td align="left">{{ area }}</td>
                    <td align="left">
                      <template v-if="$te( 'areas.' + subj )">{{ $t( "areas." + subj ) }}</template>
                      <span v-else style="color: #FF0000">не соответствует</span>
                    </td>
                  </tr>
                  </template>
                  <template v-else>
                  <tr valign="top">
                    <th colspan="2" align="center" bgcolor="LightGrey">{{ f.name }}</th>
                  </tr>
                  <tr valign="top">
                    <td colspan="2" align="center"><span style="color: #FF0000">{{ $t( "parseFailed" ) }}</span></td>
                  </tr>
                </template>
                <tr><td>&#160;</td><td>&#160;</td></tr>
              </template>
            </tbody>
          </table>
        </template>

      </div>
    </Loading>

    <div class="info">
      файлов обработано: {{ fileUploadingNum }} из {{ files.length }}
      <div class="progress"><div class="filler" :style="{ width: ( 100 * fileUploadingNum / files.length ) + '%' }"></div></div>
    </div>
  </div>
</template>

<script>

import dates from "@/dates"
import utils from "@/utils"
import config from "@/config"
import api from "@/api"
import ls from "@/ls"

import Icon from "@/components/Icon";
import Button from "@/components/Button";
import Loading from "@/components/Loading";
import Modal from "../components/Modal";
import File from "../components/File";

export default {
  name: "AstanaHUB",

  components: {
    Icon,
    Loading,
    Modal,
    Button,
    File
  },

  i18n: {
    messages: {
      ru: {
        title: "Astana Hub",
        titleDescr: "анализ документов",
        SendFiles: "Отправить файл(ы)",
        parseFailed: "предмет сделки не найден",
        subject: "предмет сделки",
        area: "направление деятельности",
        exportToExcel: "выгрузить в Excel",
        areas: {
          software:   "Разработка, внедрение, сопровождение, развитие, модификация и реализация (включая реализацию услуг, интегрированных в программно-технические возможности, путем использования в коммерческих целях, в том числе размещение платного контента, продажа встроенного дополнительного функционала) программного обеспечения и программного продукта.",
          systems:    "Создание, опытная и промышленная эксплуатация, внедрение, развитие, модификация, сопровождение информационных систем (за исключением информационных систем государственных органов).",
          data:       "Деятельность по обработке данных (обнаружение знаний в базах данных) с применением собственного или стороннего программного обеспечения.",
          science:    "Фундаментальные и прикладные исследования, экспериментальные разработки в области естественных и технических наук, выполнение научно-исследовательских, опытно-конструкторских или опытно-технологических работ в сфере информационно-коммуникационных технологий и реализация результатов таких исследований и разработок.",
          electronics:"Разработка, внедрение, сопровождение, развитие, модификация или отдельные этапы разработки (исследование, проектирование (конструирование), технические испытания и производство) технологий, устройств и систем микро-, опто- и наноэлектроники, микроэлектромеханики, монтаж печатных плат и реализация результатов таких разработок.",
          robot:      "Разработка, внедрение, сопровождение, развитие, модификация или отдельные этапы разработки (исследование, проектирование (конструирование), тестирование, технические испытания) технологий, устройств и систем робототехники и реализация результатов таких разработок.",
          radio:      "Разработка, внедрение, сопровождение, развитие, модификация, (исследование, проектирование (конструирование), тестирование, технические испытания) технологий, устройств и систем радиолокации, радионавигации, радиосвязи, радиоуправления, радиочастотной идентификации и реализация результатов таких разработок.",
          biometry:   "Разработка, внедрение, сопровождение, развитие и модификация или отдельные этапы разработки (исследование, проектирование (конструирование), прототипирование, тестирование, технические испытания), производство технологий, оборудования и устройств в сфере информационно-коммуникационных технологий, телекоммуникационных технологий, устройств и систем биометрии и реализация результатов таких разработок.",
          security:   "Разработка, внедрение, сопровождение, развитие, модификация, производство, реализация, монтаж, наладка (все вышеназванные работы вместе или часть из них) технических, программных средств обработки информации в защищенном исполнении, программных, программно-аппаратных средств в области информационной безопасности, в том числе программно-технические способы и средства обеспечения информационной безопасности.",
          cloud:      "Разработка, развитие, модификация, внедрение, эксплуатация и сопровождение программного обеспечения и (или) аппаратно-программных комплексов с использованием технологий облачных вычислений.",
          blockchain: "Разработка, внедрение, развитие, модификация, сопровождение программного обеспечения и (или) аппаратно-программных комплексов на основе или с использованием технологии блокчейн.",
          transport:  "Разработка, внедрение, сопровождение, развитие и модификация и реализация систем беспилотного управления транспортными средствами, а также систем и устройств спутниковой навигации, мобильной связи и экстренного вызова оперативных служб на транспорте.",
          ai:         "Разработка, внедрение, сопровождение, развитие, модификация или отдельные этапы разработки (исследование, проектирование (конструирование), технические испытания) технологий, устройств и систем искусственного интеллекта и реализация результатов таких разработок.",
          broker:     'Деятельность по оказанию услуг по предоставлению через Интернет программно-технических возможностей для установления контактов и совершения сделок между продавцами и покупателями (предоставление торговой площадки, функционирующей в Интернет в режиме реального времени) с использованием программного обеспечения, правообладателем которого является участник Международного технологического парка "Астана Хаб", в том числе сопутствующих услуг в рамках совершаемых сделок, интегрированных в программно-технические возможности торговой площадки.',
          iot:        "Разработка, сопровождение, развитие, модификация, внедрение, реализация концепции вычислительно-коммуникационной сети физических предметов, оснащенных встроенными технологиями для взаимодействия друг с другом или внешней средой (интернет-вещей).",
          games:      "Разработка, внедрение, сопровождение, развитие, модификация и реализация (включая реализацию услуг, интегрированных в программно-технические возможности, путем использования в коммерческих целях, в том числе размещение платного контента, продажа встроенного дополнительного функционала) компьютерных, мобильных, онлайн игр (видеоигр).",
          education:  "Оказание услуг по обучению в сфере информационно-коммуникационных технологий по следующим направлениям: архитектура и администрирование программного обеспечения в том числе продакт-менеджмент, архитектура и администрирование сетевых систем, проектирование и разработка информационных систем, архитектура и проектирование решений в области интернета вещей, разработка решений на основе программной и аппаратной платформ, разработка операционных систем, разработка веб приложений, алгоритмы (искусственный интеллект, криптография и другие), анализ и работа с большими данными, разработка мобильных приложений, безопасность в сфере информационно-коммуникационных технологий, разработка интерактивных 3D-приложений, приложений с виртуальной и дополненной реальностью, разработка видеоигр, языки программирования.",
          vr:         "Разработка, внедрение, сопровождение, развитие, модификация или отдельные этапы разработки (исследование, проектирование, технические испытания) технологий виртуальной и дополненной реальности, устройств, программ и реализация результатов таких разработок.",
          datacenter: "Услуги по обеспечению комплексной вычислительной инфраструктурой для выполнения вычислительных операций и обработки данных (за исключением центров обработки данных (Data-центров), предоставляющих инфраструктуру лицам, осуществляющим деятельность по цифровому майнингу)."
        }
      },

      en: {
      },

      kz: {
      }
    }
  },

  utils,

  data() {
    return {
      loading: false,

      file: null,

      files: [],
      filesFn: null,
      filesDatas: [],
      fileUploadingNum: 0, //affected while from 1
    };
  },

  methods: {
    fileSelected( el, fn ) {
      this.file = el.files[0];
      this.files = el.files;
      this.filesFn = fn;
    },

    async send() {
     this.loading = true;

      this.filesDatas = [];

      for ( let f = 0; f < this.files.length; f++ ) {
        this.fileUploadingNum = f + 1;
        
        const data = {
          file:       this.files[ f ].name,
          status:     null,
          message:    null,
          definitions:null,
          comparisons:null
        };

        try {
          let ans = null;

          try {
            ans = await this.rq(
              "",
              undefined,
              this.files[ f ],
              {
              }
            );
          }
          catch ( e ) {
            ans = null;
  
            if ( e.message === "status" && e.rData ) {
              try { ans = JSON.parse( e.rData ); } catch ( e ) {}
            }
  
            if ( !ans ) throw e;
          }

          if ( ans ) {
            const status = ans.Status == "success";

            this.filesDatas.push(
              {
                status,
                name: this.files[ f ].name,
                info: status ? ans.found : null
              }
            );
          }
          else throw new Error( "empty answer" );
        }
        catch ( e ) {
          console.error( e );
  
          this.$root.$emit( "notify", { header: this.$t( "InvalidServerAnswer" ), message: e.message, type: "error" } );
        }
      }

      if ( this.filesDatas.length == this.files.length && this.filesDatas.find( i => !i.status ) === undefined ) {
        this.file = null;
        this.files = [];
        this.filesFn = null;
      }
      
      this.fileUploadingNum = 0;
      this.loading = false;
    },

    async rq( path, params, file, paramsGet ) {
      const postData = new FormData();
      let url = config.AstanaHUB.url + path;

      if ( file ) postData.append( "file", file );

      if ( params ) {
        for ( let pName in params ) {
          if ( params.hasOwnProperty( pName ) ) {
            const pVal = params[ pName ];
            postData.append( pName, pVal );
          }
        }
      }

      if ( paramsGet ) {
        let s = "";
        for ( let pName in paramsGet ) {
          if ( paramsGet.hasOwnProperty( pName ) ) {
            const pVal = paramsGet[ pName ];
            s += "&" + pName + "=" + encodeURIComponent( pVal );
          }
        }

        url += "?" + s.substr( 1 );
      }

      let ans = null;
      let ansT = null;
      let res = null;

      res = await fetch(
        url,
        {
          method:	"POST",
          headers: {
          },
          credentials: "omit",
          body:	postData
        }
      );

      if ( res.status >= 200 && res.status <= 299 ) {
        ansT = await res.text();
        ans = JSON.parse( ansT );

        return ans;
      }

      const e = new Error( "status" );
      e.rStatus = res.status;
      e.rData = await res.text();

      console.error( "Request to \"" + url + "\" is failed with status: " + e.rStatus + ", data: " + e.rData );

      throw e;
    },

    exportToFile() {
      if ( !this.fileUploadingNum && this.filesDatas && this.filesDatas.length ) {
        this.tableToExcel( this.$refs.excel, "result.xls", "Результаты обработки" );
      }
    },

    tableToExcel( table, filename, worksheetName ) {
      const uri = 'data:application/vnd.ms-excel;base64,';
      const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
      const base64 = s => window.btoa( unescape( encodeURIComponent( s ) ) );
      const format = ( s, c ) => s.replace( /{(\w+)}/g, ( m, p ) => c[ p ] );
      const downloadURI = ( uri, name ) => {
        const link = document.createElement( "a" );
        link.download = name;link.href = uri;
        link.click();
        link.remove();
     };
      if ( !table.nodeType ) table = document.getElementById( table );
      const ctx = { worksheet: worksheetName || 'Worksheet', table: table.innerHTML };
      const resuri = uri + base64( format( template, ctx ) );
      downloadURI( resuri, filename );
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 1em;
}

h1 {
  font-weight: bold;
  font-size: 2em;
  margin-bottom: 0.8em;
  color: #0081CA;
}
h1 span {
  font-size: 0.8em;
  padding-left: 0.5em;
  color: #000000;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.results {
  margin-top: 2em;
}

.results th {
  color: #007BC1;
}

.results th,
.results td {
  padding: 0.2em 1em;
  text-align: left;
  vertical-align: top;
}

.results tbody tr:hover td {
  background-color: #F0F0F0;
}
/*
.results tr > *:first-child {
  padding-left: 0;
}
.results tr > *:last-child {
  padding-right: 0;
}
*/
.results thead th,
.results thead td {
  font-weight: normal;
  color: #0081CA;
  padding-bottom: 0.25em;
  border: solid #0081CA;
  border-width: 0 0 1px 0;
  text-transform: uppercase;
}
.results thead ~ tbody > tr:first-child td,
.results thead ~ tbody > tr:first-child th {
  padding-top: 0.75em;
}
.results thead .file {
  background-color: #0081CA;
  color: #FFFFFF;
  font-weight: bold;
}
.results thead th > span,
.results thead td > span {
  font-weight: bold;
  text-transform: none;
}

.results tbody td {
  color: #000000;
  padding-bottom: 1em;
}
.results tbody td:first-child {
}
.results tbody td:last-child {
  font-weight: bold;
}

.infoWrapper {
  display: inline-block;
	position: relative;
  box-sizing: border-box;
  min-width: 100%;
  min-height: 100%;
}
.infoWrapper > .info {
  display: none;
}
.infoWrapper > .info .progress {
  margin-top: 1em;
  width: 100%;
  height: 7px;
  border: solid 1px #0081CA;
  background-color: #FFFFFF;
}
.infoWrapper > .info .progress > .filler {
  height: 100%;
  background-color: #0081CA;
}

.infoWrapper.uploading {
 pointer-events: none;
}

.infoWrapper.uploading  > .info {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  z-index: 1000;
}
</style>
